import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useOnboarding } from '@/pages/Onboarding/context';

import { ScreenHairColor as ScreenHairColorFemale } from '../../../OwnAI/screens/HairColor';
import { LayoutDataType } from '../../types';

export const ScreenHairColor: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  const { wizard } = useOnboarding();

  if (gender === 'male') {
    wizard.nextStep();
    return null;
  }

  return <ScreenHairColorFemale />;
};
